import type sv from '../sv/auth'

const auth: typeof sv = {
  login: {
    brand: 'HUB AI',
    title: 'Sign in',
    emailHint: 'Enter your email address to receive a one-time code.',
    otpHint: 'Enter the 6-digit code sent to {{email}}.',
    inviteHint: 'You have been invited to {{project}}. Sign in to join.',
    emailLabel: 'Email',
    emailPlaceholder: 'name@company.com',
    continue: 'CONTINUE',
    sending: 'SENDING...',
    or: 'OR',
    continueWithGoogle: 'Continue with Google',
    continueWithMicrosoft: 'Continue with Microsoft',
    verify: 'Verify code',
    verifying: 'Verifying...',
    changeEmail: 'Change email',
    resendIn: 'Resend in {{seconds}}s',
    resending: 'Sending...',
    resend: 'Send new code',
    devCode: 'Development mode – code: {{code}}',
  },
  notice: {
    codeSent: 'We have sent a code to your email.',
    codeResent: 'New code sent.',
    inviteInvalid: 'The invitation has expired or is invalid.',
    staleSession: 'Your session has expired. Please sign in again.',
  },
  requestError: {
    domainNotAllowed:
      'This email domain does not have access. Contact an administrator to be invited.',
    deliveryFailed: 'Could not deliver the email code right now. Please try again shortly.',
    generic: 'Could not send the code. Please try again.',
  },
  otpError: {
    invalid: 'The code is incorrect. Check it and try again.',
    expired: 'The code has expired. Send a new code.',
    alreadyUsed: 'The code has already been used. Send a new code.',
    attemptsExceeded: 'Too many incorrect attempts. Request a new code.',
    invalidChallenge: 'The sign-in session became invalid. Start over with your email.',
    staleSession: 'The session expired. Please sign in again.',
    missingChallenge: 'The challenge is missing. Start over with your email.',
    generic: 'Invalid code or session. Please try again.',
  },
  resendError: {
    throttled: 'Wait for the countdown to finish before sending again.',
    expired: 'The code has expired. Request a new sign-in from the email step.',
    alreadyUsed: 'The code has already been used. Start over with your email.',
    attemptsExceeded: 'Too many attempts. Start over with your email.',
    invalidChallenge: 'The sign-in session became invalid. Start over with your email.',
    generic: 'Could not send a new code yet.',
  },
  oauthError: {
    domainNotAllowed:
      'This email domain does not have access. Contact an administrator to be invited.',
    tokenExchangeFailed: 'Sign-in failed. Please try again.',
    invalidState: 'The sign-in session expired. Please try again.',
    missingParams: 'Sign-in failed. Please try again.',
    noEmail: 'No email address was received from the provider.',
    accessDenied: 'Sign-in was cancelled.',
    generic: 'Sign-in failed. Please try again.',
  },
  brand: {
    taglineLead: 'Your ',
    taglineHighlight: 'Digital Co-worker',
    taglineMiddle: 'that does the jobs ',
    taglineEmphasis: 'in between',
    taglineEnd: '.',
    secureLogin: 'Secure sign-in',
  },
}

export default auth
